/* Candywrap v2 header: menu op desktop opent pas bij klikken (smal paneel onder het item) en sluit bij klikken ernaast of Esc. */
(function () {
  var mq = window.matchMedia('(min-width: 769px)');
  function init() {
    var menu = document.querySelector('store-header main-menu');
    if (!menu || menu.__cw) return; menu.__cw = true;
    var sel = '.main-nav > li > details';
    /* hover mag het menu niet meer openen of sluiten */
    menu.addEventListener('mouseenter', function (e) { if (mq.matches && e.target.closest && e.target.closest('.main-nav')) e.stopPropagation(); }, true);
    document.addEventListener('mouseenter', function (e) { if (mq.matches && e.target.matches && e.target.matches('.js-overlay, .js-closes-menu')) e.stopPropagation(); }, true);
    function setOpen(d, on) {
      d.classList.toggle('is-open', on);
      if (on) d.setAttribute('open', ''); else d.removeAttribute('open');
      var s = d.querySelector(':scope > summary'); if (s) s.setAttribute('aria-expanded', on ? 'true' : 'false');
    }
    function closeAll(except) { menu.querySelectorAll(sel + '.is-open').forEach(function (d) { if (d !== except) setOpen(d, false); }); }
    menu.addEventListener('click', function (e) {
      if (!mq.matches) return;
      var sum = e.target.closest(sel + ' > summary');
      if (!sum) return;
      e.preventDefault(); e.stopPropagation();
      var d = sum.parentElement, isOpen = d.classList.contains('is-open');
      closeAll(d); setOpen(d, !isOpen);
    }, true);
    document.addEventListener('click', function (e) { if (mq.matches && !e.target.closest(sel)) closeAll(); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeAll(); });
    /* bij openen geen hele-pagina overlay */
    menu.querySelectorAll(sel).forEach(function (d) { setOpen(d, false); });
  }
  if (document.readyState !== 'loading') init(); else document.addEventListener('DOMContentLoaded', init);
})();

/* & in koppen vervangen door een span met Outfit */
(function () {
  function amp(root) {
    (root || document).querySelectorAll('h1, h2, h3, .dt, .pg-h, .product-title, .ch, .cw-help2__h').forEach(function (h) {
      if (h.__amp || h.textContent.indexOf('&') < 0) return; h.__amp = true;
      var w = document.createTreeWalker(h, NodeFilter.SHOW_TEXT), n, list = [];
      while ((n = w.nextNode())) if (n.nodeValue.indexOf('&') > -1 && !(n.parentNode.classList && n.parentNode.classList.contains('cw-amp'))) list.push(n);
      list.forEach(function (t) {
        var parts = t.nodeValue.split('&'), f = document.createElement('span'); f.className = 'cw-amp-w';
        parts.forEach(function (p, i) { if (i) { var s = document.createElement('span'); s.className = 'cw-amp'; s.textContent = '&'; f.appendChild(s); } f.appendChild(document.createTextNode(p)); });
        t.parentNode.replaceChild(f, t);
      });
    });
  }
  if (document.readyState !== 'loading') amp(); else document.addEventListener('DOMContentLoaded', function () { amp(); });
})();

/* menu: items die met 'Alle' beginnen dikgedrukt */
(function () {
  function mark() { document.querySelectorAll('store-header .child-nav__item').forEach(function (a) { if (/^\s*Alle\s/i.test(a.textContent)) a.classList.add('cw-all'); }); }
  if (document.readyState !== 'loading') mark(); else document.addEventListener('DOMContentLoaded', mark);
})();

/* Productkaarten op de hele site: 'Meer info' opent het snelvenster (cw-quick-view.js) op desktop en mobiel, met onderaan een roze knop
   naar de productpagina. Ook bij snoepmixen (die hadden de maatkiezer op Meer info): die knop krijgt dan het snelvenster, de + blijft
   de maatkiezer. Met Ctrl/Cmd-klik gaat Meer info direct naar de productpagina in een nieuw tabblad. */
(function () {
  window.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('.cw-qv-btn');
    if (!b) return;
    var u = b.getAttribute('data-cw-qv') || b.getAttribute('data-cw-mixpick') || b.getAttribute('href');
    if (!u) return;
    if (window.__cwQv && !(e.ctrlKey || e.metaKey)) {
      if (!b.getAttribute('data-cw-qv')) b.setAttribute('data-cw-qv', u);
      b.removeAttribute('data-cw-mixpick');
      return; /* cw-quick-view.js opent het venster */
    }
    e.preventDefault(); e.stopImmediatePropagation(); e.stopPropagation();
    if (e.ctrlKey || e.metaKey) window.open(u, '_blank'); else window.location.href = u;
  }, true);
})();

/* Winkelwagen: cadeau met maar 1 smaak toont geen keuzelijst, en het bonnetje werkt zich direct bij na een wijziging */
(function () {
  function fixFlavors() {
    document.querySelectorAll('.cw-choice__body').forEach(function (b) {
      var sel = b.querySelector('.cw-choice__flavor'), lab = b.querySelector('.cw-choice__sublabel'), one = b.querySelector('.cw-choice__single');
      if (!sel || !one) return;
      var opts = [].filter.call(sel.options, function (o) { return o.value && !o.disabled; });
      var active = sel.style.display !== 'none' || sel.dataset.cwOne === '1';
      if (active && opts.length === 1) {
        if (sel.style.display !== 'none') sel.style.display = 'none';
        if (lab && lab.style.display !== 'none') lab.style.display = 'none';
        if (one.textContent !== opts[0].text) one.textContent = opts[0].text;
        if (one.style.display !== '') one.style.display = '';
        sel.dataset.cwOne = '1';
        if (sel.value !== opts[0].value) { sel.value = opts[0].value; sel.dispatchEvent(new Event('change', { bubbles: true })); }
      } else if (sel.dataset.cwOne === '1') {
        sel.dataset.cwOne = ''; one.style.display = 'none';
        if (opts.length > 1) { sel.style.display = ''; if (lab) lab.style.display = ''; }
      }
    });
  }
  var origFetch = window.fetch, timer;
  function refreshReceipt() {
    clearTimeout(timer);
    timer = setTimeout(function () {
      var s = document.getElementById('cart-summary'), cur = document.querySelector('.cw-receipt');
      if (!s || !cur || !origFetch) return;
      var id = s.getAttribute('data-section'); if (!id) return;
      origFetch.call(window, location.pathname + '?section_id=' + encodeURIComponent(id), { credentials: 'same-origin' })
        .then(function (r) { return r.ok ? r.text() : ''; })
        .then(function (h) {
          if (!h) return;
          var d = new DOMParser().parseFromString(h, 'text/html'), nw = d.querySelector('.cw-receipt'), now = document.querySelector('.cw-receipt');
          if (nw && now && nw.innerHTML !== now.innerHTML) now.innerHTML = nw.innerHTML;
        }).catch(function () {});
    }, 600);
  }
  function isCart(u) { return /\/cart\/(add|change|update|clear)(\.js)?/.test(String(u || '')); }
  if (origFetch) {
    window.fetch = function (input) {
      var u = typeof input === 'string' ? input : (input && input.url);
      var p = origFetch.apply(this, arguments);
      if (isCart(u)) p.then(function (r) { if (r && r.ok) refreshReceipt(); }).catch(function () {});
      return p;
    };
  }
  var xo = XMLHttpRequest.prototype.open, xs = XMLHttpRequest.prototype.send;
  XMLHttpRequest.prototype.open = function (m, u) { this.__cwCart = isCart(u); return xo.apply(this, arguments); };
  XMLHttpRequest.prototype.send = function () { if (this.__cwCart) this.addEventListener('load', function () { if (this.status < 400) refreshReceipt(); }); return xs.apply(this, arguments); };
  function start() {
    var box = document.querySelector('[data-cw-choices]');
    if (!box) return;
    fixFlavors();
    new MutationObserver(fixFlavors).observe(box, { childList: true, subtree: true });
    box.addEventListener('change', function () { setTimeout(fixFlavors, 60); });
    box.addEventListener('click', function () { setTimeout(fixFlavors, 60); });
  }
  if (document.readyState !== 'loading') start(); else document.addEventListener('DOMContentLoaded', start);
})();
